import React from 'react'

const CheckIcon = () => (
	<svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1 4.75L6.89474 10L15 1" stroke="#96BDD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
) 

export default CheckIcon